import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07d4a1e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oktell-page create-new-order" }
const _hoisted_2 = { class: "create-new-order__title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "24",
  viewBox: "0 0 22 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "cursor-pointer"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.939341 10.9393C0.353554 11.5251 0.353554 12.4749 0.939341 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.939341 10.9393ZM22 10.5L2 10.5V13.5L22 13.5V10.5Z",
    fill: "black",
    "fill-opacity": "0.6"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Оформление заказа", -1))
const _hoisted_5 = {
  key: 0,
  class: "create-new-order__results"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "results__title" }, "Результаты расчета", -1))
const _hoisted_7 = { class: "results__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_oktell_calculator = _resolveComponent("oktell-calculator")!
  const _component_oktell_calculator_results = _resolveComponent("oktell-calculator-results")!
  const _component_oktell_create_ltl_order = _resolveComponent("oktell-create-ltl-order")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { path: '/oktell/clients', query: _ctx.$route.query }
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_4
    ]),
    _createVNode(_component_oktell_calculator, { onSubmit: _ctx.onCalculatorSubmit }, null, 8, ["onSubmit"]),
    (_ctx.calculator_state.is_form_submited)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_oktell_calculator_results, {
              loading: _ctx.calculator_state.is_loading,
              "from-city-name": _ctx.calculator_state.from_city_name,
              "where-city-name": _ctx.calculator_state.where_city_name,
              "is-has-pickup": _ctx.calculator_state.is_has_pickup,
              "is-has-self-delivery": _ctx.calculator_state.is_has_self_delivery,
              cost: _ctx.calculator_state.econom.result,
              days: _ctx.calculator_state.econom.days,
              "insurance-cost": _ctx.calculator_state.econom.insuranceCost,
              "unload-cost": _ctx.calculator_state.econom.unloadCost,
              "packaging-cost": _ctx.calculator_state.econom.packagingCost,
              "tariff-id": _ctx.calculator_state.tariff_id,
              "used-weight-in-kg": _ctx.calculator_state.econom.usedWeightInKg,
              "weight-type-to-calculate": _ctx.calculator_state.econom.weightTypeToCalculate,
              "additional-service-delivery": _ctx.calculator_state.econom.additionalServiceDelivery,
              "additional-service-take": _ctx.calculator_state.econom.additionalServiceTake,
              "shipment-type-id": 1,
              "declared-price": _ctx.calculator_state.declaredPrice,
              "product-name": _ctx.calculator_state.productName
            }, null, 8, ["loading", "from-city-name", "where-city-name", "is-has-pickup", "is-has-self-delivery", "cost", "days", "insurance-cost", "unload-cost", "packaging-cost", "tariff-id", "used-weight-in-kg", "weight-type-to-calculate", "additional-service-delivery", "additional-service-take", "declared-price", "product-name"]),
            _createVNode(_component_oktell_calculator_results, {
              loading: _ctx.calculator_state.is_loading,
              "from-city-name": _ctx.calculator_state.from_city_name,
              "where-city-name": _ctx.calculator_state.where_city_name,
              "is-has-pickup": _ctx.calculator_state.is_has_pickup,
              "is-has-self-delivery": _ctx.calculator_state.is_has_self_delivery,
              cost: _ctx.calculator_state.express.result,
              days: _ctx.calculator_state.express.days,
              "insurance-cost": _ctx.calculator_state.express.insuranceCost,
              "unload-cost": _ctx.calculator_state.express.unloadCost,
              "packaging-cost": _ctx.calculator_state.express.packagingCost,
              "tariff-id": _ctx.calculator_state.tariff_id,
              "used-weight-in-kg": _ctx.calculator_state.express.usedWeightInKg,
              "weight-type-to-calculate": _ctx.calculator_state.express.weightTypeToCalculate,
              "additional-service-delivery": _ctx.calculator_state.express.additionalServiceDelivery,
              "additional-service-take": _ctx.calculator_state.express.additionalServiceTake,
              "shipment-type-id": 2,
              "is-cities-equals": _ctx.calculator_state.is_cities_equals,
              "declared-price": _ctx.calculator_state.declaredPrice,
              "product-name": _ctx.calculator_state.productName
            }, null, 8, ["loading", "from-city-name", "where-city-name", "is-has-pickup", "is-has-self-delivery", "cost", "days", "insurance-cost", "unload-cost", "packaging-cost", "tariff-id", "used-weight-in-kg", "weight-type-to-calculate", "additional-service-delivery", "additional-service-take", "is-cities-equals", "declared-price", "product-name"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_oktell_create_ltl_order, {
      disabled: _ctx.order_state.is_loading,
      "order-created": _ctx.order_state.is_created,
      onSubmit: _ctx.onOrderSubmit,
      onReset: _ctx.onOrderReset
    }, null, 8, ["disabled", "order-created", "onSubmit", "onReset"])
  ]))
}